// extracted by mini-css-extract-plugin
export default {"imagen":"Hero_imagen__7y5oT","texto":"Hero_texto__YtaSc"};